var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path0, _g8, _path1, _g9, _path10, _g0, _path11, _g1, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairsIndoorFloor1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 116,
    viewBox: "0 0 285 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_411)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00042 7.35987H77.4404V107.36H8.00042V7.35987Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4407 57.2798H203.681V54.7198H77.4407V57.2798Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.52 30.3999H203.68H203.36H203.52Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.52 30.3999H203.68H203.36",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.3998H203.36L203.68 30.5598V30.3998ZM203.36 30.3998L203.68 30.5598H203.2L203.36 30.3998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36 30.3998H203.68V30.5598M203.36 30.3998L203.68 30.5598M203.36 30.3998L203.2 30.5598H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.56H203.2L203.68 30.72V30.56ZM203.2 30.56L203.68 30.72H203.04L203.2 30.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2 30.56H203.68V30.72M203.2 30.56L203.68 30.72M203.2 30.56L203.04 30.72H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.7199H203.04L203.68 30.8799V30.7199ZM203.04 30.7199L203.68 30.8799H203.04V30.7199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.04 30.7199H203.68V30.8799M203.04 30.7199L203.68 30.8799M203.04 30.7199V30.8799H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.8798H203.04L203.68 31.0398V30.8798ZM203.04 30.8798L203.68 31.0398H203.04V30.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.04 30.8798H203.68V31.0398M203.04 30.8798L203.68 31.0398M203.04 30.8798V31.0398H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.04H203.04L203.68 31.2V31.04ZM203.04 31.04L203.68 31.2H203.04V31.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.04 31.04H203.68V31.2M203.04 31.04L203.68 31.2M203.04 31.04V31.2H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.1999H203.04L203.68 31.3599V31.1999ZM203.04 31.1999L203.68 31.3599H203.04V31.1999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.04 31.1999H203.68V31.3599M203.04 31.1999L203.68 31.3599M203.04 31.1999V31.3599H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.36H203.04L203.68 31.52V31.36ZM203.04 31.36L203.68 31.52H203.2L203.04 31.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.04 31.36H203.68V31.52M203.04 31.36L203.68 31.52M203.04 31.36L203.2 31.52H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.5199H203.2L203.68 31.6799V31.5199ZM203.2 31.5199L203.68 31.6799H203.2V31.5199ZM203.68 31.6799H203.2H203.36H203.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2 31.5199H203.68V31.6799M203.2 31.5199L203.68 31.6799M203.2 31.5199V31.6799M203.68 31.6799H203.2M203.68 31.6799H203.36H203.2",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.2 31.6799H203.68H203.36",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.36 31.6798H203.52H203.68H203.36ZM203.52 31.6798H203.68V31.8398L203.52 31.6798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.52 31.6798H203.36H203.68M203.52 31.6798H203.68M203.52 31.6798L203.68 31.8398V31.6798",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.36 31.6799H203.68",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.3999H203.84",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 30.3999H203.68H203.84H204Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 30.3998H203.68L204.16 30.5598L204 30.3998ZM203.68 30.3998L204.16 30.5598H203.68V30.3998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.3998H204L204.16 30.5598M203.68 30.3998L204.16 30.5598M203.68 30.3998V30.5598H204.16",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.16 30.56H203.68L204.32 30.72L204.16 30.56ZM203.68 30.56L204.32 30.72H203.68V30.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.56H204.16L204.32 30.72M203.68 30.56L204.32 30.72M203.68 30.56V30.72H204.32",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.32 30.7199H203.68L204.32 30.8799V30.7199ZM203.68 30.7199L204.32 30.8799H203.68V30.7199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.7199H204.32V30.8799M203.68 30.7199L204.32 30.8799M203.68 30.7199V30.8799H204.32",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.32 30.8798H203.68L204.32 31.0398V30.8798ZM203.68 30.8798L204.32 31.0398H203.68V30.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 30.8798H204.32V31.0398M203.68 30.8798L204.32 31.0398M203.68 30.8798V31.0398H204.32",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.32 31.04H203.68L204.32 31.2V31.04ZM203.68 31.04L204.32 31.2H203.68V31.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.04H204.32V31.2M203.68 31.04L204.32 31.2M203.68 31.04V31.2H204.32",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.32 31.1999H203.68L204.32 31.3599V31.1999ZM203.68 31.1999L204.32 31.3599H203.68V31.1999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.1999H204.32V31.3599M203.68 31.1999L204.32 31.3599M203.68 31.1999V31.3599H204.32",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.32 31.36H203.68L204.16 31.52L204.32 31.36ZM203.68 31.36L204.16 31.52H203.68V31.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.36H204.32L204.16 31.52M203.68 31.36L204.16 31.52M203.68 31.36V31.52H204.16",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.16 31.5199H203.68L204.16 31.6799V31.5199ZM203.68 31.5199L204.16 31.6799H203.68V31.5199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.5199H204.16V31.6799M203.68 31.5199L204.16 31.6799M203.68 31.5199V31.6799H204.16",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 31.6799H203.68H204.16H204Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.84 31.6799H203.68H204H203.84Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_62_411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -313,
    y: -18,
    width: 995,
    height: 337
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M681.12 318.4V-17.9201H-312.8V318.4H681.12Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_62_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.68 31.6798H203.84L203.68 31.8398V31.6798Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M203.681 54.72H191.041V7.35997H203.681V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.04 54.72H178.4V7.35997H191.04V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4 54.72H165.76V7.35997H178.4V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M165.761 54.72H153.121V7.35997H165.761V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M153.12 54.72H140.48V7.35997H153.12V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140.48 54.72H127.84V7.35997H140.48V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.84 54.72H115.2V7.35997H127.84V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 54.72H102.56V7.35997H115.2V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M102.561 54.72H90.0805V7.35997H102.561V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0801 54.72H77.4401V7.35997H90.0801V54.72Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4407 57.2798H203.681V59.8398H77.4407V57.2798Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.48 59.8399H127.84M127.84 59.8399V83.6799M127.84 59.8399H115.2V107.36",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 59.8399H102.56V107.36H115.2V59.8399Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.561 59.8399H90.0805V107.36H102.561V59.8399Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0801 59.8399H77.4401V107.36H90.0801V59.8399Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.48 59.8399L115.2 107.36",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M203.681 31.0399H40.0007V83.6799",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 83.6799H127.84",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.64 83.6798L122.88 86.0798L127.84 83.6798L122.72 81.2798L124.64 83.6798Z",
    stroke: "black",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.48,
    height: 115.04,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsIndoorFloor1);
export default __webpack_public_path__ + "static/media/stairs_indoor_floor1.29b03a92df3470f4208fae849db37e09.svg";
export { ForwardRef as ReactComponent };